// extracted by mini-css-extract-plugin
module.exports = {"desktopContainer":"cart-coupon-form_desktopContainer__uXGjS"};